import React from 'react';

export default function BearTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="32.88,35.38 10.72,35.38 13.26,16.17 35.43,16.17" fill="#53392E" />
      <polygon points="10.72,35.38 32.88,35.38 26.74,23.83 4.57,23.83" fill="#110B09" opacity="0.95" />
      <polygon points="10.72,35.38 4.57,23.83 7.12,4.62 13.26,16.17" fill="#110B09" opacity="0.95" />
      <polygon points="35.03,37.95 9.17,37.95 12.14,15.54 38.0,15.54" fill="#53392E" />
      <polygon points="9.17,37.95 35.03,37.95 27.86,24.46 2.0,24.46" fill="#110B09" opacity="0.95" />
      <polygon points="9.17,37.95 2.0,24.46 4.97,2.05 12.14,15.54" fill="#110B09" opacity="0.95" />
    </svg>
  );
}
